/**
 * Created by jimmy on 2022/7/1.
 */

import React, { useState, useEffect, useRef } from 'react';
import 'braft-editor/dist/index.css';
import Page from '../../components/page';
const PageModel = props => {
  return (
    <Page {...{
      ...props,
      breadcrumbs: [ { label: '景点信息' }, { label: '游船信息' } ],
      title: '游船信息'
    }}>
      <section className="formation-container" style={{ minHeight: window.innerHeight }}>
        游船信息
      </section>
    </Page>
  );
};

export default PageModel;
